import { render, staticRenderFns } from "./ApproveWebpart.vue?vue&type=template&id=246de795"
import script from "./ApproveWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ApproveWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports